import React from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, LabelList, ResponsiveContainer, Label, Customized, Legend } from "recharts";
import { DataCard } from "../../../surveys/tabulations/DataCard";

const COLORS = [
    '#c00000',
    '#c00000',
    '#c00000',
    '#c00000',
    '#c00000',
    '#c00000',
    '#c00000',
    '#ff9800',
    '#ff9800',
    '#006414',
    '#006414'
];

const renderCustomizedLabel = (props) => {

	const { x, y, width, value } = props;

	return (
        <text
            x={x + width / 2}
            y={y - 10}
            fill="#000"
            textAnchor="middle"
            style={{ fontWeight: 600, fontSize: 12 }}

        >
            { `${ value }%` }
        </text>
	);
};

export const RecomendationCharts = ({ data:{ grafica, indicador, meta, cumplimiento, legenda, total }}) => {

	return (
        <>
            {/* <ResponsiveContainer width="100%" height="50%" style={{ background: '#F4F5F6', borderRadius: 6, position: 'relative' }}> */}
            <div style={{ background: '#F4F5F6', borderRadius: 6 }}>
                <Customized 
                    component={<span style={{ position: 'absolute', fontSize: 15, fontWeight: 600, margin: '5px 0px 0px 10px' }}
                >
                    Recomendación</span>} 
                />
                <BarChart
                    width={600}
                    height={300}
                    data={grafica}
                    margin={{
                        top: 55,
                        right: 20,
                        left: 20,
                        bottom: 25,
                    }}
                >
                    <CartesianGrid strokeDasharray="5 5" />
                    <XAxis dataKey="name">
                        <Label value={ `Encuestas: ${ total }` } fill="black" position="bottom" style={{ fontSize: 15, fontWeight: 600 }} />
                    </XAxis>
                    <YAxis />
                    <Legend payload={legenda} content={ <RenderLegend colors={ ['#c00000', '#ff9800', '#006414'] } /> } verticalAlign="top" />
                    <LabelList dataKey="name" content={renderCustomizedLabel} />
                    <Bar dataKey="value" minPointSize={5}>
                        <LabelList dataKey="value" content={renderCustomizedLabel} />wi
                        {grafica.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index]} radius={4} />
                        ))}
                    </Bar>
                </BarChart>
            </div>
            {/* </ResponsiveContainer> */}

            <div style={{ display: 'flex', gap: 5, margin: '10px 0px 10px 0px' }}>
                <DataCard 
                    title="Indicador" 
                    value={ indicador === 0 ? '-' : `${ indicador }%` } 
                    background="#E9EBED"
                    color="#212529"
                />

                 <DataCard 
                    title={ `Meta ${ new Date().getFullYear() }` }
                    value={ `${ meta }%` }
                    background="#E9EBED"
                    color="#212529"
                />

                <DataCard 
                    title="Desempeño" 
                    value={ cumplimiento === 0 ? '-' :`${ cumplimiento }%` } 
                    background="#495057"
                    color="#fff"
                />
            </div>
        </>
	);
}

const RenderLegend = (props) => {

	const { payload, colors } = props;

	return (
        <ul style={{ width: '100%', display: 'flex', gap: 30, justifyContent: 'center', marginBottom: 20 }}>
            {payload.map((entry, index) => (
                <li style={{ color: colors[index] }} key={`item-${index}`}>
                    <span style={{ color: '#000', fontSize: 13, fontWeight: 600 }}>{`${ entry.name } ${ entry.value }%`}</span>
                </li>
            ))}
        </ul>
	);
}